import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface InternalCommitteeMember {
  sno: number;
  memberName: string;
  designation: string;
  position: string;
}

@Component({
  selector: 'app-instructors-page-two',
  templateUrl: './instructors-page-two.component.html',
  styleUrls: ['./instructors-page-two.component.scss']
})
export class InstructorsPageTwoComponent implements OnInit {
  isToggled = false;

  committeeMembers: InternalCommitteeMember[] = [
    {
      sno: 1,
      memberName: 'Dr. S. Muthupoogodi',
      designation: 'Associate Professor – S & H',
      position: 'Coordinator'
    },
    {
      sno: 2,
      memberName: 'Dr. K.R. Ramela',
      designation: 'Professor – Embedded System Technologies',
      position: 'Member'
    },
    {
      sno: 3,
      memberName: 'Dr. V. Vasanthi',
      designation: 'Associate Professor – S & H',
      position: 'Member'
    },
    {
      sno: 4,
      memberName: 'Ms. P. Geetha',
      designation: 'Assistant Professor – MBA',
      position: 'Member'
    },
    {
      sno: 5,
      memberName: 'Ms. P. Jebane',
      designation: 'Assistant Professor – ECE',
      position: 'Member'
    },
    {
      sno: 6,
      memberName: 'Ms. P. Praveena',
      designation: 'Non – Teaching Staff',
      position: 'Member'
    },
    {
      sno: 7,
      memberName: 'Ms. S. Kanjana',
      designation: 'Student (III year CSE)',
      position: 'Student Member'
    },
    {
      sno: 8,
      memberName: 'Ms. Atchaya',
      designation: 'Student (III year EEE)',
      position: 'Student Member'
    }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  trackBySno(index: number, item: InternalCommitteeMember): number {
    return item.sno;
  }
}